import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { getQueryParameter } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';

type UseReportPageLoadedFromLinkClick = () => void;

export const useReportPageLoadedFromLinkClick: UseReportPageLoadedFromLinkClick = () => {
  const integrationOrigin = getQueryParameter('trk_integration_origin') as string;
  const emailId = getQueryParameter('trk_email_id') as string;
  const subEvent = getQueryParameter('trk_sub_event') as string;
  const scenarioType = getQueryParameter('trk_scenario_type') as string;
  const threadId = getQueryParameter('trk_thread_id') as string;

  useEffect(() => {
    if (integrationOrigin && scenarioType) {
      reportUsage({
        eventName: AnalyticsEventName.PageLoadedFromLinkClick,
        eventProperties: {
          scenarioType,
          subEvent,
          integrationOrigin,
          emailId,
          threadId,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
